import React from 'react'

function AddWorkPermit() {
  return (
    <div>AddWorkPermit</div>
  )
}

export default AddWorkPermit